import { Card, DialogContent, Grid, styled, Typography } from "@mui/material";

export const StyledChangePassword = {
  DialogContent: styled(DialogContent)(({ theme }) => ({
    color: "#484848",
    margin: 0,
    padding: 0,
    overflow: "hidden",
  })),
  Container: styled("div")(({ theme }) => ({
    marginTop: -20,
    marginRight: 5,
    marginBottom: 0,
  })),
  Fields: styled("div")(({ theme }) => ({
    marginTop: 10,
  })),
};

export const StyledChangePasswordContainer = {
  GridContainer: styled(Grid)({
    flex: 1,
    alignItems: "center",
    backgroundImage: "linear-gradient(120deg, #96d43a, #539aff)",
  }),

  LogoImage: styled("img")({
    paddingBottom: "60px",
  }),

  LoginCard: styled(Card)({
    minWidth: "450px",
    backgroundColor: "white",
    boxShadow: "0px 0px 5px 0px grey",
    borderRadius: "10px",
    padding: "30px 25px 10px 25px",
  }),

  LoginContainer: styled(Grid)({
    marginBottom: 50,
    marginTop: 50,
  }),

  Text: styled(Typography)({
    color: "#303030",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "bold",
    fontSize: "medium",
  }),
};
